import {Injectable} from '@angular/core';
import {AngularFireAuth} from '@angular/fire/compat/auth';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree} from '@angular/router';

import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';

import {UnrApiService} from '../../core/api/api.service';
import {UnrSettingsService} from '../../services/settings/settings.service';
import {UserRegistration} from '../../core/api/resources/user-registration.resource';
import {Setting} from '../../services/settings/setting';
import { User } from '@angular/fire/auth';


@Injectable({providedIn: 'root'})
export class UnrLoginGuard implements CanActivate {

  constructor(private firebaseAuth: AngularFireAuth,
              private router: Router,
              private settings: UnrSettingsService,
              private unrApiService: UnrApiService) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<UrlTree | boolean> {
    return this.firebaseAuth
      .user
      .pipe(
        map((user: User | null) => {
          if (user !== undefined && user !== null) {
            console.log(user);
            this.unrApiService
              .registerUser(user.email)
              .subscribe(
                (userRegistration: UserRegistration) => {
                  const settings: Array<Setting> = userRegistration.settings;
                  if (userRegistration.settings) {
                    this.settings.setAllSettings(settings);
                  }
                  if (this.settings.getShowWelcomeScreen()) {
                    this.router.navigate(['welcome']);
                  } else {
                    this.router.navigate(['roadtrips']);
                  }
                }
              );
            return false;
          }
          return true;
        })
      );
  }
}
